// Support-contact constants, sourced from the active market registry so a
// per-site build (lusuku.ug -> UG, lusuku.co.zm -> ZM) renders the right
// helpline. UG values equal today's hardcoded pair
// ("0323 300 212" / "tel:+256323300212"), so Uganda output is unchanged.
import { SUPPORT_PHONE, SUPPORT_TEL } from "./config/market";

export const CUSTOMER_CARE_NUMBER = SUPPORT_PHONE;
export const CUSTOMER_CARE_TEL = SUPPORT_TEL;
